// extracted by mini-css-extract-plugin
export default {"modal":"index_modal__X2l2m","darkModeModal":"index_darkModeModal__qQYeE","subTitle":"index_subTitle__ntGue","cancel":"index_cancel__OaKui"};